export default {
  list: [
    {
      value: 'WAITING_CONFIRMATION',
      title: 'در‌انتظار تایید'
    },
    {
      value: 'CONFIRMED',
      title: 'تایید شده'
    }
  ],
  values: {
    WAITING_CONFIRMATION: 'WAITING_CONFIRMATION',
    CONFIRMED: 'CONFIRMED'
  }
};
